import { defineMessages } from "react-intl";
import { renderChip } from "../../../components/chip/ChipRenderer.js";
import "../../../components/chip/Chips.js";
import "../../../components/chip/ListWithChipTooltip.js";
import "../../../components/chip/SquaredChipList.js";
import "react";
import "@mui/material";
import "../../../components/icons/Icon.js";
import "../../../components/icons/ExpandMoreIcon.js";
import "@mui/x-data-grid";
import "uuid";
import "../../../components/alerts/InfoMessage.js";
import "../../../components/alerts/NoAccessInfoMessage.js";
import "../../../components/alerts/Message.style.js";
import "../../../components/alerts/InfoAlert.js";
import "../../../components/alerts/InfoMessageHoc.js";
import "../../../components/checkbox/StyledCheckbox.js";
import "fast-deep-equal/es6";
import "../../../components/pagination/StyledPagination.js";
import "../../../components/data-grid/mui/GridColumnsButton.js";
import "../../../components/data-grid/mui/GridColumnsPanel.js";
import "../../../components/data-grid/mui/hooks/useGridCellStyle.js";
import "../../../components/data-grid/mui/hooks/useGridLocalization.js";
import "fast-deep-equal";
import "../../../components/data-grid/mui/hooks/useGridStyle.js";
import "immer";
import "../../../components/data-grid/mui/cells/InvalidDataCell.js";
import { withDataGridEntityServer, withDataGridEntityClient } from "../../../components/data-grid/mui/DataGridEntity.js";
import { MuiDataGridClient } from "../../../components/data-grid/mui/MuiDataGridClient.js";
import { MuiDataGridServer } from "../../../components/data-grid/mui/MuiDataGridServer.js";
import { DataGridEntityConfigFactory } from "../../../components/data-grid/mui/types.js";
import { renderAmountCurrencyCellWithTooltip } from "../../../components/data-grid/mui/cells/CurrencyCell.js";
import "../../../components/data-grid/mui/cells/DateCell.js";
import { renderCellWithTooltip } from "../../../components/data-grid/mui/cells/GridCellWithTooltip.js";
import "../../../components/data-grid/mui/cells/LabelsCell.js";
import "../../../components/data-grid/mui/cells/NumberCell.js";
import { renderCellHeader } from "../../../components/data-grid/mui/cells/TextCell.js";
import "../../../components/link/LinkHOC.js";
import "../../../components/link/LinkButton.js";
import "../../../components/data-grid/mui/cells/ActionWithConfirmationButton.js";
import "../../../components/data-grid/mui/cells/TextListWithTooltipCell.js";
import "../../../components/label/EmptyLabel.js";
import "../../../components/label/LabelHoc.js";
import "../../../components/data-grid/mui/cells/DurationCell.js";
import "../../../components/data-grid/mui/cells/PercentCell.js";
import "../../../components/modal/BulkModalContent.js";
import "../../../components/modal/BulkModalProvider.js";
import "../../../components/modal/ModalButtons.js";
import "../../../components/modal/Modal.style.js";
import "../../../components/button/Buttons.js";
import "../../../components/button/EditButton.js";
import "../../../components/error/ErrorAccordion.js";
import "../../../components/error/ErrorDetails.js";
import "../../../components/error/localize.js";
import "../../../components/error/ErrorModal.js";
import "../../../components/error/GlobalServerErrorMessage.js";
import "@opentelemetry/api";
import "../../../otel/TraceProvider.js";
import "react-error-boundary";
import "rxjs/operators";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "../../../components/modal/types.js";
import "../../../components/modal/ActionConfirmationModal.js";
import "../../../components/data-grid/mui/cells/ButtonCell.js";
import { BackpackItemStatusTypeName } from "../constants.js";
const localizedHeaders = defineMessages({
  bonusName: {
    id: "DataGridBackpack_bonusName",
    defaultMessage: "Bonus Name"
  },
  bonusStatus: {
    id: "DataGridBackpack_bonusStatus",
    defaultMessage: "Ticket Status"
  },
  createdAt: {
    id: "DataGridBackpack_createdAt",
    defaultMessage: "Timestamp"
  },
  marketingCode: {
    id: "DataGridBackpack_marketingCode",
    defaultMessage: "Bonus Code"
  },
  serialNumber: {
    id: "DataGridBackpack_serialNumber",
    defaultMessage: "Serial Number"
  },
  usedAt: {
    id: "DataGridBackpack_usedAt",
    defaultMessage: "Used At"
  },
  value: {
    id: "DataGridBackpack_value",
    defaultMessage: "Value of Ticket"
  },
  toolLabel: {
    id: "DataGridBackpack_toolLabel",
    defaultMessage: "MTT Label"
  }
});
class DataGridBackpackConfigFactory extends DataGridEntityConfigFactory {
  getColumnConfig() {
    const columnsMapping = {
      bonus_name: {
        field: "bonus_name",
        valueGetter: (_, row) => this.getBonusName(row),
        renderHeader: () => renderCellHeader(localizedHeaders.bonusName),
        renderCell: renderCellWithTooltip,
        sortable: false,
        flex: 1.2
      },
      bonus_status: {
        field: "bonus_status",
        valueGetter: (_, row) => this.getBonusStatus(row),
        renderHeader: () => renderCellHeader(localizedHeaders.bonusStatus),
        renderCell: (p) => renderChip(p.value, BackpackItemStatusTypeName),
        sortable: false,
        flex: 1
      },
      "created_at.seconds": {
        field: "created_at.seconds",
        valueGetter: (_, row) => this.getCreatedDate(row),
        renderHeader: () => renderCellHeader(localizedHeaders.createdAt),
        renderCell: renderCellWithTooltip,
        sortable: false,
        flex: 1.5
      },
      marketing_code: {
        field: "marketing_code",
        valueGetter: (_, row) => this.getMarketingCode(row),
        renderHeader: () => renderCellHeader(localizedHeaders.marketingCode),
        renderCell: renderCellWithTooltip,
        sortable: false,
        flex: 1
      },
      serial_number: {
        field: "serial_number",
        valueGetter: (_, row) => this.getSerialNumber(row),
        renderHeader: () => renderCellHeader(localizedHeaders.serialNumber),
        renderCell: renderCellWithTooltip,
        sortable: false,
        flex: 0.7
      },
      "used_at.seconds": {
        field: "used_at.seconds",
        valueGetter: (_, row) => this.getUsedDate(row),
        renderHeader: () => renderCellHeader(localizedHeaders.usedAt),
        renderCell: renderCellWithTooltip,
        sortable: false,
        flex: 1.5
      },
      value: {
        field: "value",
        valueGetter: (_, row) => this.getValueWithCurrency(row),
        renderHeader: () => renderCellHeader(localizedHeaders.value),
        renderCell: renderAmountCurrencyCellWithTooltip,
        sortable: false,
        flex: 1
      },
      tool_label: {
        field: "tool_label",
        valueGetter: (_, row) => this.getToolLabel(row),
        renderHeader: () => renderCellHeader(localizedHeaders.toolLabel),
        renderCell: renderCellWithTooltip,
        sortable: false,
        flex: 1.2
      }
    };
    return columnsMapping;
  }
  getBonusName(model) {
    return model?.bonus_name;
  }
  getBonusStatus(model) {
    return model?.bonus_status;
  }
  getCreatedDate(model) {
    return model?.created_at;
  }
  getMarketingCode(model) {
    return model?.marketing_code;
  }
  getSerialNumber(model) {
    return model?.serial_number;
  }
  getUsedDate(model) {
    return model?.used_at;
  }
  getValueWithCurrency(model) {
    return { amount: model?.value, currency: this.getCurrency(model) };
  }
  getCurrency(model) {
    return model?.currency;
  }
  getToolLabel(model) {
    return model?.tool_label;
  }
}
const DataGridBackpackClient = withDataGridEntityClient(
  MuiDataGridClient,
  () => new DataGridBackpackConfigFactory().getColumnConfig()
);
const DataGridBackpackServer = withDataGridEntityServer(
  MuiDataGridServer,
  () => new DataGridBackpackConfigFactory().getColumnConfig()
);
export {
  DataGridBackpackClient,
  DataGridBackpackConfigFactory,
  DataGridBackpackServer
};
//# sourceMappingURL=DataGrid.js.map
